import { render, staticRenderFns } from "./UserListPage.vue?vue&type=template&id=87efe89c&scoped=true&"
import script from "./UserListPage.vue?vue&type=script&lang=js&"
export * from "./UserListPage.vue?vue&type=script&lang=js&"
import style0 from "./UserListPage.vue?vue&type=style&index=0&id=87efe89c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87efe89c",
  null
  
)

export default component.exports